// debuggingStore.ts

import { persistentAtom } from "@nanostores/persistent"

// A persistent store to track the visibility of the debugging overlay

export const showDebuggingMarginsStore = persistentAtom<boolean>(
  "showDebuggingMarginsOverlay",
  false,
  {
    encode: JSON.stringify,
    decode: (value) => (value ? JSON.parse(value) : false),
  }
)
